import { SportsGroupedByDateRequest, DateRange } from "sb-resp-lib";

export type datesQueryFactory = (from: Date, timeRange: DateRange.TimeRangeEnum, sportId: string) => SportsGroupedByDateRequest;

export const datesQueryFactory: datesQueryFactory = (from: Date, timeRange: DateRange.TimeRangeEnum, sportId: string) => {
    return {
        id: sportId,
        eventState: SportsGroupedByDateRequest.EventStateEnum.PreLive,
        dateRange: {
            from,
            timeRange
        }
    };
};
